import * as lib from '../lib'
import { IFetchItems, IFetchRevenueAgencyDropDown, IRevenueAgencyDropDown } from '../types'

export const listRevenueAgencyDropDown = async (
	signal?: AbortSignal | null,
	token?: string | null,
): Promise<IFetchItems<IRevenueAgencyDropDown>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: lib.filterSetup([]),
		s: lib.sortSetup([['id', 'desc']]),
		skip: lib.skipSetup(0),
		take: lib.takeSetup('all'),
	}
	const uri: string = 'revenue/agency/drop-down'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchRevenueAgencyDropDown>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchRevenueAgencyDropDown): IRevenueAgencyDropDown => {
			return {
				id: item.id,
				name: item.name ?? '?',
				isSystem: item.isSystem ?? '?',
				fakeType: item.fakeType ?? '?',
			}
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
